<div
  class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
  style="
    min-height: 200px;
    background-size: cover;
    background-position: center top;
  "
>
  <span class="mask bg-gradient-primary opacity-8"></span>
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="display-2 text-white">Formulário de cadastro</h1>
        <p class="text-white mt-0 mb-5">Novo cadastro de empresa</p>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt--7">
  <div class="row">
    <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
      <div class="card card-profile shadow">
        <div class="row justify-content-center">
          <div class="col-lg-3 order-lg-2">
            <div class="card-profile-image">
              <a href="javascript:void(0)">
                <img
                  [src]="
                    companyForm.get('foto')?.value
                      ? companyForm.get('foto')?.value
                      : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg'
                  "
                  class="rounded-circle"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
          <div class="d-flex justify-content-between">
            <a
              href="javascript:void(0)"
              (click)="openModal()"
              class="btn btn-sm btn-success mr-4"
              >Editar Foto</a
            >
            <!-- <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#cropperModal" (click)="openModal()">Selecionar Imagem</button> -->
          </div>
        </div>
        <div class="card-body pt-0 pt-md-4">
          <div class="text-center mt-7">
            <h3>
              {{
                (companyForm.get("nomeFantasia")?.value ||
                  company?.nomeFantasia ||
                  "Nova empresa") | titlecase
              }}
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-8 order-xl-1">
      <div class="card bg-secondary shadow">
        <div class="card-header bg-white border-0">
          <div class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ id ? "Editar empresa" : "Cadastro de empresa" }}
              </h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- *ngIf="companyProfileForm" -->
          <form [formGroup]="companyForm" (submit)="formSubmit()">
            <h6 class="heading-small text-muted mb-4">Informações Gerais</h6>
            <div class="pl-lg-4">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="cnpj">CNPJ</label>
                    <input
                      id="cnpj"
                      (blur)="consultarCNPJ()"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="cnpj"
                      placeholder="cnpj"
                      mask="000.000.000-00||00.000.000/0000-00"
                    />
                  </div>
                </div>
                <div class="col-lg-5">
                  <div class="form-group">
                    <label class="form-control-label" for="email"
                      >E-mail (primeiro acesso lojista)</label
                    >
                    <input
                      id="email"
                      type="email"
                      class="form-control form-control-alternative"
                      formControlName="email"
                      placeholder="email@empresa.com"
                    />
                    <small class="text-muted"
                      >Usado no primeiro acesso do painel lojista</small
                    >
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="form-control-label" for="isOnline"
                      >É virtual?</label
                    >
                    <br />
                    <label class="custom-toggle">
                      <input
                        type="checkbox"
                        name="isOnline"
                        formControlName="isOnline"
                      />
                      <span class="custom-toggle-slider rounded-circle"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label class="form-control-label" for="nomefantasia"
                      >Nome Fantasia</label
                    >
                    <input
                      id="nomefantasia"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="nomeFantasia"
                      placeholder="Nome Fantasia"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label class="form-control-label" for="razaosocial"
                      >Razão Social</label
                    >
                    <input
                      id="razaosocial"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="razaoSocial"
                      placeholder="Razão Social"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="form-control-label" for="cep">CEP</label>
                    <input
                      id="cep"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="cep"
                      placeholder="cep"
                    />
                  </div>
                </div>
                <div class="col-lg-7">
                  <div class="form-group">
                    <label class="form-control-label" for="endereco"
                      >Endereço</label
                    >
                    <input
                      id="endereco"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="endereco"
                      placeholder="Endereço"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label class="form-control-label" for="numero">Nº</label>
                    <input
                      id="numero"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="numero"
                      placeholder="Nº"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="bairro"
                      >Bairro</label
                    >
                    <input
                      id="bairro"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="bairro"
                      placeholder="Bairro"
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="bairro"
                      >Complemento</label
                    >
                    <input
                      id="complemento"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="complemento"
                      placeholder="Complemento"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="municipio"
                      >Município</label
                    >
                    <input
                      id="municipio"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="municipio"
                      placeholder="Município"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <label class="form-control-label" for="uf">UF</label>
                    <input
                      id="uf"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="uf"
                      placeholder="UF"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="categoria"
                      >Categoria</label
                    >
                    <select
                      id="categoria"
                      class="form-control form-control-alternative"
                      formControlName="categoria"
                    >
                      <option value="">Selecione</option>
                      <option
                        *ngFor="let cat of categories"
                        [value]="cat.description"
                      >
                        {{ cat.description }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="cashbackPercentual"
                      >Cashback (%)</label
                    >
                    <input
                      id="cashbackPercentual"
                      type="number"
                      step="0.1"
                      min="0.1"
                      max="100"
                      class="form-control form-control-alternative"
                      formControlName="cashbackPercentual"
                      placeholder="5"
                    />
                    <small class="text-muted"
                      >Padrão do app: 5% se não informado</small
                    >
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="limiteCompra"
                      >Limite de compra (R$)</label
                    >
                    <input
                      id="limiteCompra"
                      type="number"
                      step="1"
                      min="1"
                      class="form-control form-control-alternative"
                      formControlName="limiteCompra"
                      placeholder="200"
                    />
                    <small class="text-muted"
                      >Padrão do app: R$ 200 se não informado</small
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="status"
                      >Status</label
                    >
                    <select
                      id="status"
                      class="form-control form-control-alternative"
                      formControlName="status"
                    >
                      <option [ngValue]="1">Ativa</option>
                      <option [ngValue]="0">Inativa</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <h6 class="heading-small text-muted mb-4">Localização no mapa</h6>
            <div class="pl-lg-4" formGroupName="geolocalizacao">
              <div class="row">
                <div class="col-lg-12">
                  <div style="margin-bottom: 10px">
                    <button
                      type="button"
                      class="btn btn-info"
                      (click)="buscarCidade()"
                      style="padding: 10px 15px; cursor: pointer"
                    >
                      Centralizar Cidade no mapa
                    </button>
                  </div>
                  <div id="map" style="height: 500px"></div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="latitude"
                      >Latitude</label
                    >
                    <input
                      id="latitude"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="lat"
                      placeholder="Latitude"
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="longitude"
                      >Longitude</label
                    >
                    <input
                      id="longitude"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="lng"
                      placeholder="Longitude"
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label class="form-control-label" for="accuracy"
                      >Precisão</label
                    >
                    <input
                      id="accuracy"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="accuracy"
                      placeholder="Precisão"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <h6 class="heading-small text-muted mb-4">Telefones</h6>
            <div class="pl-lg-4">
              <div class="row">
                <div class="col-lg-6">
                  <div formArrayName="telefones">
                    <div
                      *ngFor="
                        let telefoneCtrl of telefones.controls;
                        let i = index
                      "
                    >
                      <div class="form-group">
                        <label class="form-control-label" for="telefone-{{ i }}"
                          >Telefone {{ i + 1 }}</label
                        >
                        <input
                          id="telefone-{{ i }}"
                          type="text"
                          [formControlName]="i"
                          placeholder="Digite o telefone"
                          class="form-control form-control-alternative"
                        />
                        <a
                          *ngIf="i > 0"
                          (click)="removerTelefone(i)"
                          class="btn btn-sm"
                          ><i class="ni ni-fat-remove"></i> Remover</a
                        >
                      </div>
                      <div
                        *ngIf="telefoneCtrl.invalid && telefoneCtrl.touched"
                        class="error-messages"
                      >
                        <div *ngIf="telefoneCtrl.hasError('required')">
                          O telefone é obrigatório.
                        </div>
                        <div *ngIf="telefoneCtrl.hasError('pattern')">
                          Telefone inválido. Insira um formato válido.
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <button
                    class="btn btn-success"
                    type="button"
                    (click)="adicionarTelefone()"
                  >
                    <i class="ni ni-fat-add"></i> Adicionar Telefone
                  </button>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <h6 class="heading-small text-muted mb-4">Redes Sociais</h6>
            <div class="pl-lg-4">
              <div class="row" formGroupName="socials">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="form-control-label" for="facebook"
                      >Facebook</label
                    >
                    <input
                      type="text"
                      id="facebook"
                      class="form-control form-control-alternative"
                      formControlName="facebook"
                      placeholder="Facebook"
                    />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="form-control-label" for="instagram"
                      >Instagram</label
                    >
                    <input
                      id="instagram"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="instagram"
                      placeholder="Instagram"
                    />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="form-control-label" for="linkedin"
                      >Linkedin</label
                    >
                    <input
                      id="linkedin"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="linkedin"
                      placeholder="Linkedin"
                    />
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label class="form-control-label" for="whatsapp"
                      >WhatsApp</label
                    >
                    <input
                      id="whatsapp"
                      type="text"
                      class="form-control form-control-alternative"
                      formControlName="whatsapp"
                      placeholder="WhatsApp"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <button type="submit" class="btn btn-info">Salvar</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div #modalCropper class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Recortar Imagem</h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeModal()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <input
          type="file"
          #fileInput
          (change)="onFileChange($event)"
          accept="image/*"
          class="form-control"
        />
        <div class="row">
          <div class="col-lg-8">
            <div style="width: 300px; height: 300px; overflow: hidden">
              <img
                #image
                id="image"
                class="img-fluid mt-3 rounded shadow"
                style="max-width: 100%"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div *ngIf="croppedImage">
              <p>Pré-visualização:</p>
              <img [src]="croppedImage" class="img-fluid border rounded" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-success"
          (click)="uploadImage()"
          [disabled]="!croppedImage"
        >
          Enviar
        </button>
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>
